import Svg, { type SvgProps, Path } from 'react-native-svg'

export function ClockIcon(props: SvgProps) {
  return (
    <Svg width={24} height={24} fill="none" {...props}>
      <Path
        stroke={props.color ?? '#131214'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 8v4l2.5 1m5.5-1a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      />
    </Svg>
  )
}
